const Zendesk = require('./zendesk');
const Mixpanel = require('./mixpanel');
const Clarity = require('./clarity');
const GoogleTagManager = require('./gtm');
const FirebaseMobile = require('./firebase-mobile');

module.exports = {
	Zendesk,
	Mixpanel,
	Clarity,
	GoogleTagManager,
	FirebaseMobile,
};
